import React from "react";

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";

export default function AstkStackedRoom1({ formData, setFormData }) {
  return (
    <>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">Stacked Room 1 (After works)</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Room 1 Name"
                  label="Room's Name"
                  // placeholder="Room's Name"
                  value={formData.stackedRoom1Name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      stackedRoom1Name: e.target.value,
                    })
                  }
                />
                <FormControl fullWidth>
                  <InputLabel id="StackedRoom1TypeOf-label">
                    Type of room
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="StackedRoom1TypeOf-label"
                    label="Type of room"
                    id="StackedRoom1TypeOf"
                    value={formData.stackedRoom1TypeOf}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stackedRoom1TypeOf: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="bedroom">bedroom</MenuItem>
                    <MenuItem value="bathroom">bathroom</MenuItem>
                    <MenuItem value="livingroom">livingroom</MenuItem>
                    <MenuItem value="kitchen">kitchen</MenuItem>
                    <MenuItem value="office">office</MenuItem>
                    <MenuItem value="corridor">corridor</MenuItem>
                    <MenuItem value="basement">basement</MenuItem>
                  </Select>
                </FormControl>

                <FormControl sx={{}} variant="outlined">
                  <OutlinedInput
                    id="StackedRoom1Volume"
                    value={formData.stackedRoom1Volume}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stackedRoom1Volume: e.target.value,
                      })
                    }
                    endAdornment={
                      <InputAdornment position="end">m3</InputAdornment>
                    }
                    aria-describedby="StackedRoom1Volume"
                    inputProps={{
                      "aria-label": "Volume",
                    }}
                  />
                </FormControl>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="StackedRoom1LateralWall1-label">
                    Lateral wall 1
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="StackedRoom1LateralWall1-label"
                    label="Lateral wall 1"
                    id="StackedRoom1LateralWall1"
                    value={formData.stackedRoom1LateralWall1}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stackedRoom1LateralWall1: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="mur massif 10cm">mur massif 10cm</MenuItem>
                    <MenuItem value="mur massif 20cm">mur massif 20cm</MenuItem>
                    <MenuItem value="mur massif 30cm">mur massif 30cm</MenuItem>
                    <MenuItem value="mur massif 40cm">mur massif 40cm</MenuItem>
                    <MenuItem value="mur massif 10cm + doublage acoustique">
                      mur massif 10cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 20cm + doublage acoustique">
                      mur massif 20cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 30cm + doublage acoustique">
                      mur massif 30cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 40cm + doublage acoustique">
                      mur massif 40cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="cloison légère">cloison légère</MenuItem>
                    <MenuItem value="cloison légère + doublage acoustique">
                      cloison légère + doublage acoustique
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="StackedRoom1LateralWall2-label">
                    Lateral wall 2
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="StackedRoom1LateralWall2-label"
                    label="Lateral wall 2"
                    id="StackedRoom1LateralWall2"
                    value={formData.stackedRoom1LateralWall2}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stackedRoom1LateralWall2: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="mur massif 10cm">mur massif 10cm</MenuItem>
                    <MenuItem value="mur massif 20cm">mur massif 20cm</MenuItem>
                    <MenuItem value="mur massif 30cm">mur massif 30cm</MenuItem>
                    <MenuItem value="mur massif 40cm">mur massif 40cm</MenuItem>
                    <MenuItem value="mur massif 10cm + doublage acoustique">
                      mur massif 10cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 20cm + doublage acoustique">
                      mur massif 20cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 30cm + doublage acoustique">
                      mur massif 30cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 40cm + doublage acoustique">
                      mur massif 40cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="cloison légère">cloison légère</MenuItem>
                    <MenuItem value="cloison légère + doublage acoustique">
                      cloison légère + doublage acoustique
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="StackedRoom1LateralWall3-label">
                    Lateral wall 3
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="StackedRoom1LateralWall3-label"
                    label="Lateral wall 3"
                    id="StackedRoom1LateralWall3"
                    value={formData.stackedRoom1LateralWall3}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stackedRoom1LateralWall3: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="mur massif 10cm">mur massif 10cm</MenuItem>
                    <MenuItem value="mur massif 20cm">mur massif 20cm</MenuItem>
                    <MenuItem value="mur massif 30cm">mur massif 30cm</MenuItem>
                    <MenuItem value="mur massif 40cm">mur massif 40cm</MenuItem>
                    <MenuItem value="mur massif 10cm + doublage acoustique">
                      mur massif 10cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 20cm + doublage acoustique">
                      mur massif 20cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 30cm + doublage acoustique">
                      mur massif 30cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 40cm + doublage acoustique">
                      mur massif 40cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="cloison légère">cloison légère</MenuItem>
                    <MenuItem value="cloison légère + doublage acoustique">
                      cloison légère + doublage acoustique
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="lateralWall4-label">
                    Lateral wall 4
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="StackedRoom1LateralWall4-label"
                    label="Lateral wall 4"
                    id="StackedRoom1LateralWall4"
                    value={formData.stackedRoom1LateralWall4}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        stackedRoom1LateralWall4: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="mur massif 10cm">mur massif 10cm</MenuItem>
                    <MenuItem value="mur massif 20cm">mur massif 20cm</MenuItem>
                    <MenuItem value="mur massif 30cm">mur massif 30cm</MenuItem>
                    <MenuItem value="mur massif 40cm">mur massif 40cm</MenuItem>
                    <MenuItem value="mur massif 10cm + doublage acoustique">
                      mur massif 10cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 20cm + doublage acoustique">
                      mur massif 20cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 30cm + doublage acoustique">
                      mur massif 30cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="mur massif 40cm + doublage acoustique">
                      mur massif 40cm + doublage acoustique
                    </MenuItem>
                    <MenuItem value="cloison légère">cloison légère</MenuItem>
                    <MenuItem value="cloison légère + doublage acoustique">
                      cloison légère + doublage acoustique
                    </MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  id="StackedRoom1Notes"
                  label="Additional Notes"
                  multiline
                  rows={4}
                  value={formData.stackedRoom1Notes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      stackedRoom1Notes: e.target.value,
                    })
                  }
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
